var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart",
    d: "M12.406-3a.389.389,0,0,1-.281-.125A.389.389,0,0,1,12-3.406v-7.187a.389.389,0,0,1,.125-.281A.389.389,0,0,1,12.406-11h.688a.389.389,0,0,1,.281.125.389.389,0,0,1,.125.281v7.188a.389.389,0,0,1-.125.281A.389.389,0,0,1,13.094-3Zm-6,0a.389.389,0,0,1-.281-.125A.389.389,0,0,1,6-3.406V-9.594a.389.389,0,0,1,.125-.281A.389.389,0,0,1,6.406-10h.688a.389.389,0,0,1,.281.125.389.389,0,0,1,.125.281v6.188a.389.389,0,0,1-.125.281A.389.389,0,0,1,7.094-3Zm3,0a.389.389,0,0,1-.281-.125A.389.389,0,0,1,9-3.406V-7.594a.389.389,0,0,1,.125-.281A.389.389,0,0,1,9.406-8h.688a.389.389,0,0,1,.281.125.389.389,0,0,1,.125.281v4.188a.389.389,0,0,1-.125.281A.389.389,0,0,1,10.094-3ZM15.5-1.5a.487.487,0,0,1,.359.141A.487.487,0,0,1,16-1v.5a.487.487,0,0,1-.141.359A.487.487,0,0,1,15.5,0H1A.961.961,0,0,1,.3-.3.961.961,0,0,1,0-1V-11.5a.487.487,0,0,1,.141-.359A.487.487,0,0,1,.5-12H1a.487.487,0,0,1,.359.141A.487.487,0,0,1,1.5-11.5v10ZM3.406-3a.389.389,0,0,1-.281-.125A.389.389,0,0,1,3-3.406V-5.594a.389.389,0,0,1,.125-.281A.389.389,0,0,1,3.406-6h.688a.389.389,0,0,1,.281.125.389.389,0,0,1,.125.281v2.188a.389.389,0,0,1-.125.281A.389.389,0,0,1,4.094-3Z",
    transform: "translate(0 12)",
    fill: "#0a0a0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.96663e3765321ab8f689348efb7b353c.svg";
export { ForwardRef as ReactComponent };